import { FC } from 'react';
import ScanPageRight from './right';
import RightGoodInfo from './goodInfo';
import RightGoodItem from './goodItem';
import RightOperation from './operation';
import RightCustom from './custom';
import RightRowItem from './rowItem';
import {
  ScanPageRightProps,
  ScanPageRightGoodInfoProps,
  ScanPageRightGoodItemProps,
  ScanPageRightOperationProps,
  ScanPageRightCustomProps,
  ScanPageRightRowItemProps,
} from '../../interface';

export type IScanPageRightComponent = FC<ScanPageRightProps> & {
  GoodInfo: FC<ScanPageRightGoodInfoProps>;
  GoodItem: FC<ScanPageRightGoodItemProps>;
  Operation: FC<ScanPageRightOperationProps>;
  Custom: FC<ScanPageRightCustomProps>;
  RowItem: FC<ScanPageRightRowItemProps>;
};

const TransScanPageRight = ScanPageRight as IScanPageRightComponent;
TransScanPageRight.GoodInfo = RightGoodInfo;
TransScanPageRight.GoodItem = RightGoodItem;
TransScanPageRight.Operation = RightOperation;
TransScanPageRight.Custom = RightCustom;
TransScanPageRight.RowItem = RightRowItem;

export default TransScanPageRight;